import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clone, find } from 'lodash';
import { VirtualizedSelect } from 'containers';
import * as util from 'lib/utility';
import * as actions from 'state/modules/assign';
import styles from './PopupNoContact.css';

const debug = _debug('app:PopupNoContact');

let idMappingToValue = [];

class PopupNoContact extends Component {
  static propTypes = {
    closePopup: React.PropTypes.func,
    wholeData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    inspectionsDataAll: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    updateInspectionsData: React.PropTypes.func,
    popupErrorLabel: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    updateInspectionsDisposition: React.PropTypes.func,
    ownerId: React.PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      updateDropdownStyle: false,
      valueSelected: []
    };
  }

  componentWillMount() {
    const wholeData = this.props.wholeData;
    debug('### wholeData', wholeData);
  }

  handleDropdownChange = (value) => {
    this.setState({ value }, () => {
      if (this.state.value) {
        this.setState({ updateDropdownStyle: false });
      }
    });
  }

  updateFilter = (key, value) => {
    let valueSelected;
    const request = new Promise((resolve) => {
      valueSelected = value && value.length ? value.map(item => item.label) : [];
      this.setState({ valueSelected });
      this.setState({ updateDropdownStyle: false });
      resolve(valueSelected);
    });
    return request;
  };

  updateNoContactData = () => {
    const inspectionData = this.props.wholeData;
    const dataId = inspectionData.id;
    let correctData = {};
    const dataToUpdate = [{ suppressDuplicateErrors: 1, updates: [] }];
    const ownerId = this.props.ownerId;
    const dataDict = {
      action: 'U',
      fields: {},
      modelName: 'cica_inspections',
      modelId: dataId
    };
    if (this.state.valueSelected.length) {
      this.props.inspectionsDataAll.forEach((data) => {
        if (data.id.indexOf(dataId) > -1) {
          correctData = clone(data);
          const selectedNoContact = idMappingToValue.filter(mappingValue => (
            find(this.state.valueSelected, selectedValue => selectedValue === mappingValue.label)
          ));
          const secondNoContactValue =
            selectedNoContact.map(value => value.value);
          correctData.cica_couldnotcntowner = parseInt(secondNoContactValue); // eslint-disable-line
          correctData.cica_issubmitted = 1; // eslint-disable-line
          dataDict.fields.cica_issubmitted = true; // eslint-disable-line
          dataDict.fields.cica_couldnotcntowner = correctData.cica_couldnotcntowner; // eslint-disable-line
          dataDict.fields.cica_comments =
          correctData.cica_comments ? correctData.cica_comments : null;
          dataDict.fields.cica_disposition = 3;
          correctData.cica_customerexperience = null;
          correctData.cica_trainingopportunity = null;
          dataDict.fields.cica_customerexperience = null;
          dataDict.fields.cica_trainingopportunitystr = null;
          dataDict.fields.cica_isduplicate = false;
          correctData.cica_isduplicate = 0;
          dataToUpdate[0].updates.push(dataDict);
        }
      });
      debug('dataToUpdate', dataToUpdate);
      this.props.updateInspectionsData(correctData);
      this.props.closePopup(true);
      this.props.updateInspectionsDisposition(dataToUpdate, ownerId)
      .catch((error) => {
        debug(error);
      });
    } else {
      this.setState({ updateDropdownStyle: true });
    }
  }

  noContactlist = (list) => {
    idMappingToValue =
    list.map(item => (
      {
        value: item.value,
        label: item.label
      }));
    return list.map(item => (
      {
        value: item.label,
        label: item.label,
        clearableValue: false
      }), 'value');
  };

  render() {
    const { strings } = this.props;
    const noContactData = util.dropDownData(strings).noContactData;
    return (
      <div className={styles.popupBody}>
        <div className={styles.pageDropDown}>
          <span className={styles.labelText}>
            {strings.couldnotcontact}
          </span>
          <div className={styles.dropdown}>
            <VirtualizedSelect
              options={this.noContactlist(noContactData)}
              type={this.state.value}
              updateFilter={this.updateFilter}
              filterValues={this.state.valueSelected}
              tetherToWindow={false}
              labelKey="label"
              valueKey="value"
              placeholder={strings.select}
              hiddenSearch
              placeholderStyle
              singleSelect
              menuStyle={{ overflow: 'hidden', 'min-height': '150px' }}
              menuContainerStyle={{ 'min-height': '150px' }}
              maxHeight={190}
              className={this.state.updateDropdownStyle ? styles.pageDropDownError : undefined}
            />
            {this.state.updateDropdownStyle && this.props.popupErrorLabel}
          </div>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.updateNoContactData()}
            >{strings.submit}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closePopup()}
            >{strings.cancel}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inspectionsDataAll: state.assign.tabThreeInsData
});

export default connect(mapStateToProps, actions)(PopupNoContact);



// WEBPACK FOOTER //
// ./src/components/PopupNoContact/PopupNoContact.js